import { getTypeIcon } from "./TransactinsTable";
import attsLogo from "assets/img/attsLogo.png";
import { useTranslation } from "react-i18next";
import { TransactionOrder } from "types/User";
import { format } from "date-fns";

export const MobileTx = ({ tx }: { tx: TransactionOrder }) => {
  const { t } = useTranslation();
  return (
    <div className="w-full  bg-[#1a1a1a] p-4 rounded-[12px] shadow-lg">
      <div className="flex font-luxora-regular justify-between items-center text-12m text-white/40 mb-[4px]">
        <span>{format(new Date(tx.createdAt), "MMMM d")}</span>
        <span>{format(new Date(tx.createdAt), "HH:mm:ss")}</span>
      </div>

      <div className="flex justify-between items-center">
        <button
          className="inline-flex items-center gap-[8px] py-[10px] rounded-[8px] justify-center
                          shadow-[0px_6px_7.5px_0px_rgba(0,0,0,0.06)] bg-[#252525] pl-[8px] pr-[16px] w-fit"
        >
          {getTypeIcon("Buy")}

          <span className="font-luxora-regular text-16m leading-[110%] text-white">
            Buy
          </span>
        </button>

        <div className="flex items-center">
          <img src={attsLogo} alt="" className="max-lg:w-[36px]" />
          <span className="font-luxora-medium text-white text-14m">
            {tx.amount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>

        {/* <button className="hover:scale-110 transition-transform w-[35px] h-[35px] bg-white flex items-center justify-center duration-200 rounded-[8px] shadow-md">
          {<LinkIcon className="w-[19px] h-[19px]" />}
        </button> */}
      </div>

      <div className="flex justify-between items-center mt-3 ">
        <div >
          <p className="font-luxora-regular text-12m text-white/40">
            {t("USD Price")}
          </p>
          <p className="font-luxora-regular text-14m text-white">
            {tx.round.tokenPrice}
          </p>
        </div>
        <div >
          <p className="font-luxora-regular text-12m text-white/40">
            {t("USD Total")}
          </p>
          <p className="font-luxora-regular text-14m text-white">
            {tx?.actuallyPaidUsd ? (
              <>
                $
                {tx.actuallyPaidUsd.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </>
            ) : (
              "-"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
